import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Form, Input } from 'antd';
import { Button } from '@cropler/ui-kit';
import stylesModal from '../../../styles/modal.module.scss';
import { fieldsApi, useCreateFieldMutation } from '../../../store/api/fields';
import { Icon as CroplerIcon } from '@cropler/ui-kit';

const AddFieldForm = ({ t, fields, closeModal}) => {
  const dispatch = useDispatch();
  const [formField] = Form.useForm();
  const [createField, { isSuccess: isCreateFieldSuccess }] = useCreateFieldMutation();

  const validateFieldName = (value) => {
    return fields.find((field) => field.name === value);
  };

  const onAddField = (e) => {
    e.preventDefault();
    formField.validateFields().then(() => {});
    const fieldName = formField.getFieldValue('name');
    if (fieldName && !validateFieldName(fieldName)) {
      createField({ name: fieldName });
      closeModal();
      formField.resetFields();
    }
  };

  useEffect(() => {
    if (isCreateFieldSuccess) {
      setTimeout(() => {
        dispatch(fieldsApi.util.resetApiState());
      });
    }
  }, [isCreateFieldSuccess]);

  return (
    <Form form={formField} layout="vertical" autoComplete="off" requiredMark={false} initialValues={{ name: '' }}>
      <Form.Item
        label={t('fields.add.fieldName')}
        name="name"
        rules={[
          {
            required: true,
            message: t('fields.add.fieldNamePlaceholder'),
          },
          () => ({
            validator(_, value) {
              if (validateFieldName(value)) {
                return Promise.reject(new Error(`${value} ${t('forms.validation.smthAlreadyExists')}`));
              }
              return Promise.resolve();
            },
          }),
        ]}
      >
        <Input type="text" size={'large'} />
      </Form.Item>
      <div className={stylesModal.modalNav}>
        <Button type="secondary" onClick={() => closeModal()}>
          {t('actions.cancel')}
        </Button>
        <Button type="primary" onClick={onAddField} icon={<CroplerIcon name="check" height={20} width={20} />}>
          {t('actions.save')}
        </Button>
      </div>
    </Form>
  );
};

export default AddFieldForm;
